import WindowSills from "./WindowSillsWithDrawing";

export default WindowSills